import React from 'react';
import { Text } from '@constants/Themed';
import MarkDown from 'react-native-markdown-display';
import { rules } from '@utils/stringUtils/markDownRules';
import { themeSelector } from '@reduxLocal/selectors/themeSelector';

interface SafeMarkDownProps {
  content: string;
}

const SafeMarkDown: React.FC<SafeMarkDownProps> = React.memo(({ content }) => {
  const theme = themeSelector();
  if (!content || typeof content !== 'string' || content.trim() === '') {
    return (
      <Text style={{ fontSize: 13, color: '#666', lineHeight: 20 }}>
        No content available
      </Text>
    );
  }

  try {
    const cleanContent = content
      .replace(/\r\n/g, '\n')
      .replace(/\t/g, '  ')
      .replace(/<think>/g, '')
      .replace(/<\/think>/g, '')
      .trim();

    return (
      <MarkDown
        rules={rules}
        style={{
          body: {
            fontSize: 15,
            lineHeight: 22,
            color: theme ? 'black' : 'white'
          },
          paragraph: {
            marginVertical: 4,
            fontSize: 15,
            lineHeight: 22
          },
          heading1: {
            fontSize: 20,
            fontWeight: 'bold',
            marginVertical: 8,
            lineHeight: 24
          },
          heading2: {
            fontSize: 18,
            fontWeight: 'bold',
            marginVertical: 6,
            lineHeight: 22
          },
          heading3: {
            fontSize: 16,
            fontWeight: '600',
            marginVertical: 4,
            lineHeight: 20
          },
          code_inline: {
            backgroundColor: '#f5f5f5',
            paddingHorizontal: 4,
            paddingVertical: 2,
            borderRadius: 3,
            fontSize: 13,
            fontFamily: 'monospace'
          },
          code_block: {
            backgroundColor: '#f8f8f8',
            padding: 8,
            borderRadius: 4,
            marginVertical: 4,
            fontSize: 13,
            fontFamily: 'monospace'
          },
          blockquote: {
            borderLeftWidth: 3,
            borderLeftColor: '#ddd',
            paddingLeft: 8,
            marginVertical: 4,
            backgroundColor: '#fafafa'
          },
          list_item: {
            fontSize: 15,
            lineHeight: 22,
            marginVertical: 2
          },
          strong: {
            fontWeight: 'bold'
          },
          em: {
            fontStyle: 'italic'
          }
        }}
      >
        {cleanContent}
      </MarkDown>
    );
  } catch (error) {
    console.warn('Markdown rendering error:', error);
    return (
      <Text style={{ fontSize: 15, lineHeight: 22 }}>
        {typeof content === 'string'
          ? content.replace(/<think>/g, '').replace(/<\/think>/g, '')
          : (content ? JSON.stringify(content) : 'Error: Invalid message content')
        }
      </Text>
    );
  }
});

SafeMarkDown.displayName = 'SafeMarkDown';

export default SafeMarkDown;
















